/**
 * GTM for accounts
 */
/**
 * Selectors
 */
const selectors = {
    promotions: {
        promotion: '.gtm-promotion',
        heading: '.gtm-heading',
        link: '.gtm-link'
    },

    surveys: {
        survey: '.gtm-survey',
        heading: '.gtm-heading',
        link: '.gtm-link'
    },
};

/**
 * Datalayer push for surveys
 */

const surveys = [...document.querySelectorAll(selectors.surveys.survey)];
if (surveys.length > 0) {
    surveys.forEach((survey) => {
        const title = survey.querySelector(selectors.surveys.heading);
        const link =  survey.querySelector(selectors.surveys.link);
        // on click prevent redirect, push title to datalayer and redirect
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window.dataLayer.push({
                event: 'survey',
                surveyName: title.textContent,
            });
            window.location.href = link;
        })
    });
}


const promotions = [...document.querySelectorAll(selectors.promotions.promotion)];
if (promotions.length > 0) {
    promotions.forEach((promotion) => {
        const title = promotion.querySelector(selectors.promotions.heading);
        const link =  promotion.querySelector(selectors.promotions.link);
        // on click prevent redirect, push title to datalayer and redirect
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window.dataLayer.push({
                event: 'promotion',
                promotion: title.textContent,
            });
            window.location.href = link;
        })
    });
}

// Add Product GTM
const addProductForm = document.querySelector('.js-add-product');
if (addProductForm) {
    addProductForm.addEventListener('submit', () => {

        const type = addProductForm.querySelector('input[name="type"]').value;
        const manufacturer = addProductForm.querySelector('input[name="manufacturer"]').value;
        const model = addProductForm.querySelector('input[name="model"]').value;

        if ('dataLayer' in window) {
            window.dataLayer.push({
                event: 'newProduct',
                type,
                manufacturer,
                model
            });
        }

    });
}
